<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title" translate>Upload your document</h3>
      <hr id="hr-modal-title">
    </div>
    <div class="modal-body center-block">
      <div class="row">
        <ul id="tabs" class="nav nav-tabs nav-tabs-highlight">
          <li class="active" ><a [attr.data-toggle]="'tab'"  [attr.href]="'#single'" translate>Single Upload</a></li>
          <li><a [attr.data-toggle]="'tab'"  (click)="getTemplates()" [attr.href]="'#template-system'" translate>General Templates</a></li>
        </ul>

        <div class="tab-content">
          <div id="single" class="tab-pane fade in active">

                <uppy-dashboard [uppy]="uppy"  [props]="uppyDashboardOptions"   > </uppy-dashboard>

            </div>

          <div id="template-system" class="tab-pane fade">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <select (change)="this.selectedCategory = $event.target.value" class="form-control">
                    <option *ngFor="let category of templateCategories" [value]="category">{{category}}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-8">
                <div class="form-group">
                  <div class="has-feedback has-feedback-right searchButton">
                    <input id="searchFilter" class="form-control" [(ngModel)]="searchText" [placeholder]="translate.instant('search')" type="search">
                    <div class="form-control-feedback">
                      <i class="icon-search4 text-size-base text-muted"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="max-height: 300px; overflow-y: auto">
              <ul *ngFor="let template of templates | filter : searchText : selectedCategory" id="template-list">
                <li><a [attr.href]="null" (click)="editTemplateRecipients(template.job)">{{template.job.name}}</a></li>
              </ul>
            </div>
          </div>

        </div>
      </div>

    </div>
    <hr>
    <div class="modal-footer">
      <button type="button" id="closeModalButtonCloseOnly"  class="btn btn-hide" data-dismiss="modal">Close</button>
      <button type="button"  class="btn btn-danger legitRipple btn-lg" data-dismiss="modal" translate>Close</button>
    </div>
  </div> <!-- /.modal-content -->
</div><!-- /.modal-dialog  -->


  <div id="updateTemplateJobRecipients" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg center-modal" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <button class="close" type="button" (click)="hideEditRecipientModal()">×</button>
          <h5 class="text-semibold modal-title" translate>Edit Recipients</h5>
        </div>
        <!-- <form #f="ngForm" novalidate>-->
        <div class="modal-body" [var]="{coll: []}" #form="var">
          <!-- <br>-->
          <ul class="list-group" *ngFor="let recipient of templateRecipients; index as index">
            <li class="list-group-item">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="pull-left">{{recipientNames[index].name}}</h4>
                </div>
                <div class="col-md-6">
                  <a class="btn btn-sm btn-link pull-right" [attr.href]="null" (click)="fillRecipientWithMyInfo(index)" >
                    <i class="icon-checkmark4"></i> <strong translate>Fill with my info</strong>
                  </a>
                </div>
              </div>

              <div class="row position">
                <div class="col-xs-11">
                  <div class="form-horizontal">
                    <div class="form-group">
                      <label for="recName" class="control-label text-right col-sm-3">
                        <strong translate>Name</strong>
                      </label>
                      <div class="col-sm-9">
                        <input type="text" id="recName" name="name" class="form-control" [(ngModel)]="templateRecipients[index].name" #name="ngModel" required minlength="2" pattern="^[a-zA-ZsçÇöÖşŞıİğĞüÜ]+(([',. -][a-zA-ZsçÇöÖşŞıİğĞüÜ ])?[a-zA-ZsçÇöÖşŞıİğĞüÜ]*)*$">
                        <small [hidden]="name.valid" class="text-danger" translate>Name is required.</small>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="recEmail" class="control-label text-right col-sm-3">
                        <strong translate>Email</strong>
                      </label>
                      <div class="col-sm-9">
                        <input type="text" id="recEmail" name="email" class="form-control" [(ngModel)]="templateRecipients[index].email" #email="ngModel" required minlength="5" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$">
                        <small [hidden]="email.valid" class="text-danger" translate>Email is required and format should be <i>john&#64;doe.com</i>.</small>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="recCitizenId" class="control-label text-right col-sm-3">
                        <strong translate>Citizen ID</strong>
                      </label>
                      <div class="col-sm-9">
                        <input type="text" id="recCitizenId" name="citizenId" class="form-control" [(ngModel)]="templateRecipients[index].citizenId" #citizenId="ngModel" minlength="11" maxlength="11" pattern="[0-9]+">
                        <small [hidden]="citizenId.valid" class="text-danger" translate>CitizenId is optional (11 numeric characters).</small>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <span style="display: none !important;">{{form.coll[index]=name.valid && email.valid && citizenId.valid}}</span>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button class="btn btn-link" type="button" (click)="hideEditRecipientModal()" translate>Cancel</button>
          <button class="btn btn-primary" type="button" [disabled]="disableEditRecBtn" (click)="createJobFromTemplate(form)" translate>Create</button>
        </div>
        <!-- </form>-->
      </div>
    </div>
  </div>
